export const projectsData = [
    {
        id: 1,
        name: 'Pen Galaxy Web Application',
        img: "https://i.ibb.co/wL9CQp4/Screenshot-3.png",
        img1: "https://i.ibb.co/hy7Whvg/Screenshot-4.png",
        img2: "https://i.ibb.co/P1X66Lz/Screenshot-5.png",
        img3: "https://i.ibb.co/G39ZgbQ/Screenshot-6.png",
        shortDescription: 'This is Pen Galaxy. Pen Galaxy is a Pen Sale Web Application. In this application user could be able to buy Pens, cancel their order and many features available... ',
        description: 'This is Pens Sale Web Application. On my orders page, the logged-in user will see only his/her orders and orders status. If the user wants, he/she will be able to cancel any order. Users will be able to give reviews and the reviews will be displayed on the home page. Admin could be able to make another user an admin.',
        technology: {
            tech1: 'HTML',
            tech2: 'CSS',
            tech3: 'Bootstrap',
            tech4: 'React js',
            tech5: 'Firebase',
            tech6: 'MongoDB',
            tech7: 'Express js',
            tech8: 'Node js'
        },
        liveSite: 'https://pens-galaxy.web.app/',
        clientSideCode: 'https://github.com/Antor7080/Pens-galaxy-Client', serverSideCode: 'https://github.com/Antor7080/pens-galaxy-server'
    },
    {
        id: 2,
        name: 'Travel Web Application',
        img: "https://i.ibb.co/Ws833x9/t1.png",
        img1: "https://i.ibb.co/N6Xr2jt/t2.png",
        img2: "https://i.ibb.co/8DHWPDq/t3.png",
        img3: "https://i.ibb.co/92svYw9/t4.png",
        img4: "https://i.ibb.co/hR7hD79/t5.png",
        shortDescription: 'This is Traveler. Traveler is a tourism related Web Application. In this application user could be able to book package, cancel their booking and many features available... ',
        description: 'This is Travel Related Web Application. The details of the product that the user has clicked will be displayed on the booking page. The admin will be able to delete anyones order on the Manage Booking page. Also will be able to add a brand new service. After adding that service, this service will appear on the home page',
        technology: {
            tech1: 'HTML',
            tech2: 'CSS',
            tech3: 'Bootstrap',
            tech4: 'React js',
            tech5: 'Firebase',
            tech6: 'MongoDB',
            tech7: 'Express js',
            tech8: 'Node js'
        },
        liveSite: 'https://travler-16fc7.web.app/', clientSideCode: 'https://github.com/Antor7080/travler-server', serverSideCode: 'https://github.com/Antor7080/Traveler'
    },
    {
        id: 3,
        name: 'Health Web Application',
        img: "https://i.ibb.co/K0bBKnV/Screenshot-8.png",
        img1: "https://i.ibb.co/K0bBKnV/Screenshot-9.png",
        img2: "https://i.ibb.co/K0bBKnV/Screenshot-10.png",
        img3: "https://i.ibb.co/V9qY17x/Screenshot-11.png",
        shortDescription: 'This is Health Cheak Up. This is a medical instrument and doctor information related Web Application. Users will be able to sign in and signup using email-password and google account... ',
        description: 'This is doctor information and health care releted  Web Application. Users will be able to sign in and signup using email-password and google account. If the user is not logged in, the details page redirects to the login page. After login, the user will be redirected to the page he/she wanted to go to.',
        technology: {
            tech1: 'HTML',
            tech2: 'CSS',
            tech3: 'Bootstrap',
            tech4: 'React js',
            tech5: 'Firebase',
            tech6: 'React-Router',
        },
        liveSite: 'https://health-care-check-up-packages.web.app/', clientSideCode: 'https://github.com/Antor7080/HEALTH-CHECK-UP'
    },
]